import React from "react";

function FpgDisableIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#FF5036"
        fillRule="evenodd"
        d="M7 13.667A6.667 6.667 0 107 .334a6.667 6.667 0 000 13.333zm-3.27-2.454l7.483-7.484a5.333 5.333 0 01-7.484 7.484zm-.943-.942a5.333 5.333 0 017.484-7.484L2.787 10.27z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default FpgDisableIcon;
